export default __webpack_public_path__ + "static/6657-ed8a225ecc86ad884dff4396f109f523.jpg";